import React from 'react';

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
    <div
      className={`relative bg-[#FFFFFF] border border-gray-200 rounded-lg shadow-md p-8 sm:w-[90%] md:w-[70%] mx-auto transform transition-all duration-300 ease-out ${
        isOpen ? "scale-100 opacity-100" : "scale-95 opacity-0"
      }`}
    >
      <h2 className="text-2xl font-semibold text-gray-800 mb-3">Customer Product Details</h2>
      <button
        onClick={onClose}
        className="absolute top-8 right-10 text-white bg-[#1C50A3] w-7 h-7 flex items-center justify-center rounded-full"
      >
        &times;
      </button>
      <div className="-mx-8">
        <hr className="border-gray-300" />
      </div>
  
      <div className="max-h-[80vh] overflow-y-auto custom-scrollbar">
        {children}
      </div>
    </div>
  </div>
  
  );
};

export default Modal;
